window.m || (window.m = {});
window.v || (window.v = {});
window.URLs || (window.URLs = {});
window.Works || (window.Works = {});
window.Aedu || (window.Aedu = {});
window.c = window.Aedu;
window.Academia = window.Aedu;